import React, { memo } from 'react';
import { Margin } from '..';
import { NoReviewStyled } from './Styled';

const NoReviewByFilter = () => (
  <NoReviewStyled>
    <Margin top={100} />
    <b>Ops!</b>
    <p>Nenhuma avaliação foi encontrada com este filtro.</p>
    <Margin bottom={100} />
  </NoReviewStyled>
);

const NoReviewFilter = memo(NoReviewByFilter);

export default NoReviewFilter;
export { NoReviewFilter };
